import { CaseStatus, CaseTag, } from '@debbie/common/dist/cases/index.js';
import { Registry } from '@debbie/common/dist/debt-register/index.js';
import { DocumentTypes } from '@debbie/common/dist/documents/index.js';
import { VoucherCategory } from '@debbie/common/dist/economy/vouchers/index.js';
import { CaseVoucherCategories } from '@debbie/common/dist/economy/vouchers/setup.js';
import { PropertyDataType } from '@debbie/common/dist/properties/index.js';
import { RequirementType, ishHandledPropertyType, } from '@debbie/common/dist/workflows/index.js';
import * as customersAPI from '@debbie/cortex/dist/api/customers.js';
import { useCaseGroups } from '@debbie/cortex/dist/case-groups/index.js';
import { useAllCreditors } from '@debbie/cortex/dist/creditors/index.js';
import { useEndReasons } from '@debbie/cortex/dist/end-reasons/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { usePropertyTypes } from '@debbie/cortex/dist/properties/index.js';
import { useUpdateTypes, useUpdateTypesMap, } from '@debbie/cortex/dist/update-types/index.js';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Button from '../Button.js';
import ButtonGroup from '../ButtonGroup.js';
import Checkbox from '../Checkbox.js';
import { registryDescriptors } from '../DebtRegistration/registries.js';
import Disclaimer from '../Disclaimer.js';
import { X } from '../Icons/index.js';
import Input from '../Input.js';
import PropertyTypeSelect from '../PropertyTypeSelect.js';
import RangeInput from '../RangeInput.js';
import SearchInput from '../SearchInput.js';
import Select from '../Select.js';
import TagsEditor from '../TagsEditor.js';
const RequirementsInput = (props) => {
    const lang = useSelector((s) => s.lang);
    const updateTypesLoadable = useUpdateTypes();
    const updateTypes = h.hasData(updateTypesLoadable)
        ? updateTypesLoadable.data
        : null;
    const propertyTypesLoader = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoader)
        ? propertyTypesLoader.data.filter(ishHandledPropertyType)
        : [];
    const creditorsLoadable = useAllCreditors();
    const creditors = h.hasData(creditorsLoadable) ? creditorsLoadable.data : null;
    const { disabled, requirements, onChange } = props;
    return (React.createElement("div", null,
        requirements.map((requirement, i) => (React.createElement(RequirementEditor, { requirement: requirement, requirements: requirements, index: i, onChange: onChange, key: requirement.id, disabled: disabled }))),
        props.disabled !== true && (React.createElement(Select, { disabled: disabled, label: lang.workflows.addRequirement, searchPlaceholder: lang.inputs.search, selected: [], portal: true, options: Object.values(RequirementType)
                .filter((type) => type === RequirementType.Property
                ? propertyTypes.length > 0
                : true)
                .map((type) => ({
                value: type,
                label: lang.workflowRequirementTypes[type],
            })), onChange: ([value]) => {
                const type = Object.values(RequirementType).find((requirementType) => requirementType === value);
                const updateType = updateTypes && updateTypes[0];
                if (type !== undefined &&
                    updateType !== null &&
                    updateType !== undefined) {
                    let details = {};
                    switch (type) {
                        case RequirementType.HasUpdate:
                        case RequirementType.MissingUpdate:
                            details = {
                                updateTypeIds: [],
                                isActive: false,
                            };
                            break;
                        case RequirementType.AmountThreshold:
                            details = {
                                moreThan: true,
                                amount: 100000,
                            };
                            break;
                        case RequirementType.DebtRemarks:
                            details = {
                                max: true,
                                count: 0,
                            };
                            break;
                        case RequirementType.CaseGroup:
                            details = {
                                caseGroupIds: [],
                            };
                            break;
                        case RequirementType.PercentageSplit:
                            details = {
                                from: 0,
                                to: 0.5,
                            };
                            break;
                        case RequirementType.SpecificCreditor:
                            details = {
                                creditorIds: [],
                            };
                            break;
                        case RequirementType.CustomerHasTag:
                            details = {
                                tag: '',
                            };
                            break;
                        case RequirementType.CaseHasTag:
                            details = {
                                tag: '',
                            };
                            break;
                        case RequirementType.CaseStatusIn:
                            details = {
                                caseStatuses: [],
                            };
                            break;
                        case RequirementType.InDebtRegister:
                        case RequirementType.NotInDebtRegister:
                            details = {
                                registries: Object.values(Registry),
                                onlyOpenRegistries: false,
                            };
                            break;
                        case RequirementType.Property:
                            details = {
                                propertyTypeId: propertyTypes[0].propertyTypeId,
                                handle: propertyTypes[0].handle,
                                ref: propertyTypes[0].ref,
                                type: propertyTypes[0].type,
                                in: [
                                    PropertyDataType.singleLineText,
                                    PropertyDataType.dropdown,
                                ].includes(propertyTypes[0].type)
                                    ? []
                                    : undefined,
                                checked: propertyTypes[0].type === PropertyDataType.checkbox
                                    ? true
                                    : undefined,
                            };
                            break;
                        default:
                            break;
                    }
                    onChange(requirements.concat({
                        id: crypto.randomUUID(),
                        type,
                        details,
                    }));
                }
            } }))));
};
const RequirementEditor = (props) => {
    const lang = useSelector((s) => s.lang);
    const updateTypesLoadable2 = useUpdateTypes();
    const updateTypes = h.hasData(updateTypesLoadable2)
        ? updateTypesLoadable2.data
        : null;
    const endReasonsLoadable = useEndReasons();
    const endReasons = h.hasData(endReasonsLoadable)
        ? endReasonsLoadable.data
        : null;
    const caseGroupsLoadable = useCaseGroups();
    const caseGroups = h.hasData(caseGroupsLoadable)
        ? caseGroupsLoadable.data
        : null;
    const updateTypesMapLoadable = useUpdateTypesMap();
    const updateTypesMap = h.hasData(updateTypesMapLoadable)
        ? updateTypesMapLoadable.data
        : {};
    const creditorsLoadable = useAllCreditors();
    const creditors = h.hasData(creditorsLoadable) ? creditorsLoadable.data : null;
    const propertyTypesLoader = usePropertyTypes();
    const propertyTypes = h.hasData(propertyTypesLoader)
        ? propertyTypesLoader.data.filter(ishHandledPropertyType)
        : [];
    const { requirement, requirements, index, onChange } = props;
    const [updateTypeIds, setUpdateTypeIds] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.updateTypeIds);
    const [updateIsActive, setUpdateIsActive] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.isActive);
    const [caseGroupIds, setCaseGroupIds] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.caseGroupIds);
    const [amount, setAmount] = useState(
    // TODO: fix this
    //@ts-ignore
    `${(requirement.details.amount || 0) / 100}`);
    const [count, setCount] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.count || 0);
    const [max, setMax] = useState(
    // TODO: fix this
    //@ts-ignore
    !!requirement.details.max);
    const [percentageSplitFrom, setPercentageSplitFrom] = useState(
    // TODO: fix this
    //@ts-ignore
    `${(requirement.details.from || 0) * 100}`);
    const [percentageSplitTo, setPercentageSplitTo] = useState(requirement.type === RequirementType.PercentageSplit
        ? `${(requirement.details.to || 0) * 100}`
        : null);
    const [creditorIds, setCreditorIds] = useState(requirement.type === RequirementType.SpecificCreditor
        ? requirement.details.creditorIds
        : null);
    const [inCaseStatuses, setInCaseStatuses] = useState(requirement.type === RequirementType.CaseStatusIn
        ? requirement.details.caseStatuses
        : null);
    const [onlyEndReasonIds, setOnlyEndReasonIds] = useState(requirement.type === RequirementType.CaseStatusIn
        ? requirement.details.onlyEndReasonIds
        : undefined);
    const [propertyDetails, setPropertyDetails] = useState(
    // @ts-ignore
    requirement.type === RequirementType.Property ? requirement.details : null);
    const [propertyDetailsTextInputRaw, setPropertyDetailsTextInputRaw] = useState(propertyDetails && propertyDetails.in
        ? propertyDetails.in.join(', ')
        : '');
    const [foundationTypeState, setFoundationTypeState] = useState(requirement.type === RequirementType.HasFoundation &&
        requirement.details.foundationTypes?.length > 0
        ? {
            foundationTypes: requirement.details.foundationTypes,
            onlySelectedFoundationTypes: true,
        }
        : {
            foundationTypes: [],
            onlySelectedFoundationTypes: false,
        });
    const [tag, setTag] = useState(
    // TODO: fix this
    //@ts-ignore
    requirement.details.tag);
    const onRequirementChange = (change, overrideAll) => {
        onChange(requirements.map((_requirement, i) => {
            if (i === index) {
                const _copy = {
                    ..._requirement,
                };
                _copy.details = {
                    ..._requirement.details,
                    ...change,
                };
                if (overrideAll) {
                    _copy.details = change;
                }
                return _copy;
            }
            return _requirement;
        }));
    };
    const selectedPropertyType = propertyTypes?.find((propertyType) => propertyType.propertyTypeId === propertyDetails?.propertyTypeId);
    return (React.createElement(RequirementStyled, null,
        React.createElement("h4", null,
            lang.workflowRequirementTypes[requirement.type],
            ' ',
            !props.disabled && (React.createElement(X, { style: { float: 'right', cursor: 'pointer' }, onClick: () => onChange(requirements.filter((_, i) => index !== i)) }))),
        (() => {
            switch (requirement.type) {
                case RequirementType.HasUpdate:
                case RequirementType.MissingUpdate:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(ReactSelect, { value: (updateTypeIds || []).map((updateTypeId) => {
                                const updateType = updateTypesMap[updateTypeId];
                                return {
                                    label: lang.updateTypes[updateTypeId] ||
                                        (updateType && updateType.label) ||
                                        updateType,
                                    value: updateTypeId,
                                };
                            }), isMulti: true, placeholder: lang.cases.pauseReason, classNamePrefix: "select", options: (updateTypes || []).map((updateType) => ({
                                label: lang.updateTypes[updateType.updateTypeId] ||
                                    updateType.label,
                                value: updateType.updateTypeId,
                            })), onChange: (val) => {
                                const selected = val ? val.map((v) => v.value) : [];
                                setUpdateTypeIds(selected);
                                onRequirementChange({
                                    updateTypeIds: selected,
                                });
                            } }),
                        React.createElement("br", null),
                        React.createElement(Checkbox, { placeholder: lang.workflows.updateIsActive, checked: updateIsActive, onChange: (e) => {
                                setUpdateIsActive(e.target.checked);
                                onRequirementChange({
                                    isActive: e.target.checked,
                                });
                            } })));
                case RequirementType.AmountThreshold:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(Checkbox, { placeholder: lang.workflows.moreThan, checked: requirement.details.moreThan, onChange: (e) => onRequirementChange({
                                moreThan: e.target.checked,
                            }) }),
                        React.createElement(Input, { type: "number", placeholder: lang.workflows.thresholdAmount, value: amount, onChange: (e) => {
                                const val = e.target.value;
                                setAmount(val);
                                const isNumber = !isNaN(parseFloat(val));
                                if (isNumber) {
                                    onRequirementChange({
                                        amount: Math.round(parseFloat(val) * 100),
                                    });
                                }
                            } }),
                        React.createElement(ReactSelect, { value: requirement.details.onlySelectedCategories
                                ? requirement.details.onlySelectedCategories.map((category) => ({
                                    label: (category &&
                                        lang.economyCategories[category]) ||
                                        category,
                                    value: category,
                                }))
                                : [], isMulti: true, placeholder: lang.workflows.onlySelectedVoucherCategories, classNamePrefix: "select", options: [].concat(CaseVoucherCategories.filter((category) => ![VoucherCategory.TRANSACTION].includes(category)).map((category) => ({
                                label: lang.economyCategories[category],
                                value: category,
                            }))), onChange: (val) => {
                                const selectedCategories = val?.length
                                    ? val.map((v) => v.value)
                                    : undefined;
                                onRequirementChange({
                                    onlySelectedCategories: selectedCategories,
                                });
                            } })));
                case RequirementType.DebtRemarks:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(ButtonGroup, null,
                            React.createElement(Button, { size: "mini", theme: max ? undefined : 'secondary', onClick: () => {
                                    setMax(true);
                                    onRequirementChange({
                                        max: true,
                                    });
                                } }, lang.inputs.max),
                            React.createElement(Button, { size: "mini", theme: max ? 'secondary' : undefined, onClick: () => {
                                    setMax(false);
                                    onRequirementChange({
                                        max: false,
                                    });
                                } }, lang.inputs.min)),
                        React.createElement(RangeInput, { minValue: 0, maxValue: 30, value: count, updateWhenSteady: true, onChange: (val) => {
                                if (typeof val === 'number') {
                                    setCount(val);
                                    onRequirementChange({
                                        count: val,
                                    });
                                }
                            } })));
                case RequirementType.CaseGroup:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(ReactSelect, { value: (caseGroupIds || []).map((caseGroupId) => {
                                const caseGroup = caseGroups &&
                                    caseGroups.find((cG) => cG.id === caseGroupId);
                                return {
                                    label: (caseGroup && caseGroup.label) || caseGroupId,
                                    value: caseGroupId,
                                };
                            }), isMulti: true, placeholder: lang.workflows.caseGroup, classNamePrefix: "select", options: (caseGroups || []).map((caseGroup) => ({
                                label: caseGroup.label,
                                value: caseGroup.id,
                            })), onChange: (val) => {
                                const selected = val ? val.map((v) => v.value) : [];
                                setCaseGroupIds(selected);
                                onRequirementChange({
                                    caseGroupIds: selected,
                                });
                            } })));
                case RequirementType.PercentageSplit:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(Input, { type: "number", placeholder: lang.workflows.percentageSplitFrom, value: percentageSplitFrom, onChange: (e) => {
                                const val = e.target.value;
                                setPercentageSplitFrom(val);
                                const isNumber = !isNaN(parseFloat(val));
                                if (isNumber) {
                                    onRequirementChange({
                                        from: parseFloat(val) / 100,
                                    });
                                }
                            } }),
                        React.createElement(Input, { type: "number", placeholder: lang.workflows.percentageSplitTo, value: percentageSplitTo || '', onChange: (e) => {
                                const val = e.target.value;
                                setPercentageSplitTo(val);
                                const isNumber = !isNaN(parseFloat(val));
                                if (isNumber) {
                                    onRequirementChange({
                                        to: parseFloat(val) / 100,
                                    });
                                }
                            } })));
                case RequirementType.SpecificCreditor:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(ReactSelect, { value: (creditorIds || []).map((creditorId) => {
                                const creditor = creditors &&
                                    creditors.find((c) => c.creditorId === creditorId);
                                return {
                                    label: (creditor && creditor.name) || creditorId,
                                    value: creditorId,
                                };
                            }), isMulti: true, placeholder: lang.workflows.selectedCreditor, classNamePrefix: "select", options: (creditors || []).map((creditor) => ({
                                label: creditor.name,
                                value: creditor.creditorId,
                            })), onChange: (val) => {
                                const selected = val ? val.map((v) => v.value) : [];
                                setCreditorIds(selected);
                                onRequirementChange({
                                    creditorIds: selected,
                                });
                            } }),
                        creditorIds == null || creditorIds.length === 0 ? (React.createElement(Disclaimer, null, lang.workflows.noSelectedCreditorWarning)) : null));
                case RequirementType.CustomerHasTag:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(SearchInput, { placeholder: "Tag", autofocus: true, searchAll: async (q) => {
                                const tags = await customersAPI.getUsedTags();
                                let res = [];
                                if (tags.length) {
                                    res = res.concat(tags
                                        .filter((t) => {
                                        if (!q) {
                                            return true;
                                        }
                                        return t.toLowerCase().includes(q.toLowerCase());
                                    })
                                        .map((t) => ({
                                        heading: t,
                                        returnData: t,
                                        key: t,
                                    })));
                                }
                                if (q && !res.find((r) => r.returnData === q)) {
                                    res = res.concat({
                                        heading: q,
                                        returnData: q,
                                        key: q,
                                    });
                                }
                                return res;
                            }, static: tag || undefined, onRemoveStatic: () => setTag(''), onSelect: (t) => {
                                setTag(t);
                                onRequirementChange({
                                    tag: t,
                                });
                            } })));
                case RequirementType.CaseHasTag:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(TagsEditor, { tags: tag
                                ? [
                                    {
                                        tag: tag,
                                    },
                                ]
                                : [], onChange: (tags) => {
                                setTag(tags[0]?.tag || null);
                                onRequirementChange({ tag: tags[0]?.tag || null });
                            }, availableTags: [CaseTag.SURVEILLANCE], translations: lang.caseTags, single: true })));
                case RequirementType.HasFoundation:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(Checkbox, { placeholder: lang.workflows.onlySpecificDocumentTypes, checked: foundationTypeState.onlySelectedFoundationTypes, onChange: (e) => {
                                setFoundationTypeState({
                                    onlySelectedFoundationTypes: e.target.checked,
                                    foundationTypes: e.target.checked
                                        ? foundationTypeState.foundationTypes
                                        : [],
                                });
                                onRequirementChange({
                                    onlySelectedFoundationTypes: e.target.checked,
                                    foundationTypes: e.target.checked ? [] : undefined,
                                });
                            } }),
                        foundationTypeState.onlySelectedFoundationTypes &&
                            [
                                DocumentTypes.DOM,
                                DocumentTypes.PAATEGNING,
                                DocumentTypes.GAELDSBREV,
                                DocumentTypes.FOUNDATION,
                                DocumentTypes.SKYLDERKLAERING,
                                DocumentTypes.FORLIG,
                            ].map((documentType) => (React.createElement(Checkbox, { checkMark: true, key: documentType, placeholder: lang.documentTypes[documentType], checked: foundationTypeState.foundationTypes?.includes(documentType), onChange: (e) => {
                                    const foundationTypes = requirement.details.foundationTypes || [];
                                    const changes = e.target.checked
                                        ? foundationTypes.concat(documentType)
                                        : foundationTypes.filter((dt) => dt !== documentType);
                                    setFoundationTypeState({
                                        foundationTypes: changes,
                                        onlySelectedFoundationTypes: changes.length === 0 ? false : true,
                                    });
                                    onRequirementChange({
                                        foundationTypes: changes,
                                        onlySelectedFoundationTypes: changes.length === 0 ? false : true,
                                    });
                                } })))));
                case RequirementType.CaseStatusIn:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(ReactSelect, { value: (inCaseStatuses || []).map((status) => ({
                                label: lang.cases[status],
                                value: status,
                            })), isMulti: true, placeholder: lang.caseFilter.selectCaseStatus, classNamePrefix: "select", options: Object.values(CaseStatus).map((status) => ({
                                label: lang.cases[status],
                                value: status,
                            })), onChange: (val) => {
                                const selected = val ? val.map((v) => v.value) : [];
                                const onlySelectedIsEnded = selected.length === 1 && selected[0] === CaseStatus.ENDED;
                                onRequirementChange({
                                    caseStatuses: selected,
                                    onlyEndReasonIds: onlySelectedIsEnded ? [] : undefined,
                                });
                                setInCaseStatuses(selected);
                                setOnlyEndReasonIds(onlySelectedIsEnded ? [] : undefined);
                            } }),
                        inCaseStatuses?.length === 1 &&
                            inCaseStatuses[0] === CaseStatus.ENDED && (React.createElement(ReactSelect, { value: (onlyEndReasonIds || []).map((id) => {
                                const endReason = endReasons?.find((er) => er.id === id);
                                const name = endReason
                                    ? (lang.endReason[endReason.handle] ?? endReason.label)
                                    : id;
                                return {
                                    label: name,
                                    value: id,
                                };
                            }), isMulti: true, placeholder: lang.caseFilter.selectEndReasons, classNamePrefix: "select", options: (endReasons || []).map((endReason) => {
                                const name = lang.endReason[endReason.handle] ??
                                    endReason.label;
                                return {
                                    label: name,
                                    value: endReason.id,
                                };
                            }), onChange: (val) => {
                                let selected = val
                                    ? val.map((v) => v.value)
                                    : [];
                                selected = selected.length ? selected : undefined;
                                onRequirementChange({
                                    onlyEndReasonIds: selected,
                                    caseStatuses: inCaseStatuses,
                                });
                                setOnlyEndReasonIds(selected);
                            } }))));
                case RequirementType.Property:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(PropertyTypeSelect, { value: propertyDetails?.propertyTypeId ?? null, disabled: props.disabled, filter: ishHandledPropertyType, onChange: (_id, propertyType) => {
                                if (propertyType === null) {
                                    onChange(requirements.filter((_, i) => index !== i));
                                    return;
                                }
                                const baseDetails = {
                                    propertyTypeId: propertyType.propertyTypeId,
                                    handle: propertyType.handle,
                                    ref: propertyType.ref,
                                };
                                let details;
                                switch (propertyType.type) {
                                    case PropertyDataType.singleLineText:
                                    case PropertyDataType.dropdown:
                                        details = {
                                            ...baseDetails,
                                            type: propertyType.type,
                                            in: [],
                                        };
                                        break;
                                    case PropertyDataType.checkbox:
                                        details = {
                                            ...baseDetails,
                                            type: propertyType.type,
                                            checked: true,
                                        };
                                        break;
                                    default:
                                        return;
                                }
                                setPropertyDetailsTextInputRaw('');
                                setPropertyDetails(details);
                                onRequirementChange(details, true);
                            } }),
                        propertyDetails &&
                            [PropertyDataType.singleLineText].includes(propertyDetails.type) && (React.createElement(Input, { type: "text", placeholder: lang.workflows
                                .propertySingleLineTextOneOfFollowingStrings, value: propertyDetailsTextInputRaw, onChange: (e) => {
                                const val = e.target.value;
                                setPropertyDetailsTextInputRaw(val);
                                const _in = (val || '').split(',').map((v) => v.trim());
                                setPropertyDetails({
                                    ...propertyDetails,
                                    in: _in,
                                });
                                onRequirementChange({
                                    in: _in,
                                });
                            } })),
                        propertyDetails &&
                            [PropertyDataType.checkbox].includes(propertyDetails.type) && (React.createElement(Checkbox, { placeholder: selectedPropertyType?.label || '', checked: propertyDetails?.checked || false, onChange: (e) => {
                                const val = e.target.checked;
                                setPropertyDetails({
                                    ...propertyDetails,
                                    checked: val,
                                });
                                onRequirementChange({
                                    checked: val,
                                });
                            } })),
                        selectedPropertyType?.type &&
                            [PropertyDataType.dropdown].includes(selectedPropertyType?.type) &&
                            selectedPropertyType && (React.createElement(ReactSelect, { value: (propertyDetails?.in || []).map((option) => {
                                const val = (selectedPropertyType.data?.options || []).find((o) => o.value === option);
                                return {
                                    label: val?.text || '',
                                    value: val?.value || '',
                                };
                            }), isMulti: true, placeholder: lang.workflows.propertyDropdownOneOfFollowingValues, classNamePrefix: "select", options: (selectedPropertyType.data?.options || []).map((option) => {
                                return {
                                    label: option.text,
                                    value: option.value,
                                };
                            }), onChange: (val) => {
                                const selected = val ? val.map((v) => v.value) : [];
                                setPropertyDetails({
                                    ...propertyDetails,
                                    in: selected,
                                });
                                onRequirementChange({
                                    in: selected,
                                });
                            } }))));
                case RequirementType.InDebtRegister:
                case RequirementType.NotInDebtRegister:
                    return (React.createElement(RequirementBody, null,
                        React.createElement(Checkbox, { placeholder: lang.workflows.onlyOpenRegistries, disabled: props.disabled, checked: requirement.details.onlyOpenRegistries, onChange: (e) => onRequirementChange({
                                onlyOpenRegistries: e.target.checked,
                            }) }),
                        React.createElement(ReactSelect, { value: requirement.details.registries.map((registry) => ({
                                label: registryDescriptors[registry].label(lang),
                                value: registry,
                            })), isMulti: true, isDisabled: props.disabled, classNamePrefix: "select", options: Object.values(Registry).map((registry) => ({
                                label: registryDescriptors[registry].label(lang),
                                value: registry,
                            })), onChange: (val) => {
                                onRequirementChange({
                                    registries: val.map((v) => v.value),
                                });
                            } }),
                        requirement.details.registries.length === 0 && (React.createElement(Disclaimer, null, requirement.type === RequirementType.InDebtRegister
                            ? lang.workflows.noSelectedRegistryNeverFulfilledWarning
                            : lang.workflows.noSelectedRegistryAlwaysFulfilledWarning))));
                default:
                    return null;
            }
        })()));
};
export default RequirementsInput;
const RequirementStyled = styled.div `
  font-size: 12px;
  background: ${THEME.COLOR_SECONDARY};
  border: 1px solid ${THEME.BORDER_STRONG};
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 10px;

  h4 {
    margin: 0;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.5px;
  }
`;
const RequirementBody = styled.div `
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;
//# sourceMappingURL=RequirementsInput.js.map